import { render, staticRenderFns } from "./FrzHabilitarLotes.vue?vue&type=template&id=3c27d127"
import script from "./FrzHabilitarLotes.vue?vue&type=script&lang=js"
export * from "./FrzHabilitarLotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports